import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Management from "@/pages/Management";
import Scanner from "@/pages/Scanner";
import Reports from "@/pages/Reports";
import AIAgent from "@/pages/AIAgent";
import Personnalisation from "@/pages/Personnalisation";
import SyncMonitor from "@/pages/SyncMonitor";
import Login from "@/pages/Login";
import "./App.css";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("benjscanner_user");
    if (saved) setUser(JSON.parse(saved));
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem("benjscanner_user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem("benjscanner_user");
    setUser(null);
  };

  if (!user) return (
    <div className="App">
      <Login onLogin={handleLogin} />
      <Toaster position="top-right" richColors />
    </div>
  );

  return (
    <div className="App">
      <BrowserRouter>
        <Layout onLogout={handleLogout} user={user}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/gestion" element={<Management />} />
            <Route path="/scanner" element={<Scanner />} />
            <Route path="/rapports" element={<Reports />} />
            <Route path="/agent-ia" element={<AIAgent />} />
            <Route path="/personnalisation" element={<Personnalisation />} />
            <Route path="/synchro" element={<SyncMonitor />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}
export default App;